// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "lg-1.0.0.css";
	// return url for filenames based on template
	return "" + chunkId + ".lg-1.0.0.css";
};